var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DAE0E3;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75,
    cy: 75,
    r: 75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,145.2c22.1,0,42-13,52-26.9c0.9-1.3,1.1-3,0.5-4.4C120.3,97.9,99.6,86,75,86c-24.5,0-45.3,11.9-52.5,27.9 c-0.7,1.5-0.4,3.2,0.5,4.5C33.5,132.5,52.9,145.2,75,145.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 76.8,
    cy: 57.8,
    r: 21.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user_placeholder.f9037dd78b294d319396a58407f9fb1c.svg";
export { ForwardRef as ReactComponent };